import React, { useState } from "react";
import stepsData from "../layout/stepsData";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useSelector } from "react-redux";

const UserJourney = ({ setShowIntro }) => {
  const [stepsEnabled, setStepsEnabled] = useState(true);
  const [initialStep, setInitialStep] = useState(0);
  const loggedInUser = useSelector((state) => state.user);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setInitialStep(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStepsEnabled(false);
      setShowIntro(false);
      localStorage.setItem("introShown", true);
    }
  };

  const roles = loggedInUser.currentUser.Roles || [];
  let allSteps = [];
  roles.forEach((role) => {
    const roleData = stepsData.find((data) => data.hasOwnProperty(role));
    if (roleData) {
      const roleSteps = Object.values(roleData[role]).flat();
      allSteps = allSteps.concat(roleSteps);
    }
  });

  const uniqueSteps = allSteps.filter((step, index, array) => {
    const isFirstOccurrence = array.findIndex((s) => s.target === step.target) === index;
    return isFirstOccurrence;
  });

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        steps={uniqueSteps}
        continuous
        scrollToFirstStep
        showSkipButton
        run={stepsEnabled}
        stepIndex={initialStep}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        locale={{
          last: "Finish",
        }}
        disableOverlayClose
        disableScrolling
        disableCloseOnEsc
        disableScrollParentFix
      />
    </>
  );
};

export default UserJourney;
